import request from '@/utils/request'
import {
  User
} from '@/types'
import get from 'lodash/get'

const apiFactory = (config: User.API.Config.Settings) => {
  const { userInfoType } = config
  const setInfo = (value: User.UserSettingsState): Promise<User.UserSettingsState> => {
    return request({
      url: '/cadence-service/user-info',
      method: 'post',
      data: {
        type: userInfoType,
        info: value
      }
    })
      .then(data => get(data, 'data.info'))
  }
  const getInfo = (): Promise<User.UserSettingsState> => {
    return request({
      url: '/cadence-service/user-info',
      method: 'get',
      params: {
        type: userInfoType
      }
    })
      .then(data => get(data, 'data.0.info'))
  }
  return { getInfo, setInfo }
}

export default apiFactory
